export const curriculum = {
  // 헤더
  title: '커리큘럼 진행 상황',
  subtitle: 'A → B1 → B2 → C 4단계로 차근차근 레벨업',

  // 단계 표시
  currentLevelLabel: '현재 레벨',
  currentBadge: '현재 위치',
  completedBadge: '수료',
  upcomingBadge: '예정',

  // 레벨 설명
  levelADesc: '완전 초보자. 기본 어휘와 문법의 기초를 배웁니다.',
  levelB1Desc: '중급 기초. 일상 회화의 유창함을 기르고 어휘를 확장합니다.',
  levelB2Desc: '전문가 레벨. 뉘앙스와 관용 표현을 다듬습니다.',
  levelCDesc: '원어민에 가까운 유창함. 고급 표현을 마스터합니다.',

  // 레벨업 전환 (테스트 + 보강 2회)
  levelUpTitle: '레벨업',
  levelUpDescription: '테스트 1회 + 가정교사의 약점 보강 레슨 2회',

  // 진행 지표
  completedLessons: '완료한 레슨',
  completedLessonsUnit: '회',
  remainingLessons: '남은 레슨',
  remainingLessonsUnit: '회',
  levelTest: '레벨업 테스트',
  levelTestPassed: '합격',
  levelTestNotPassed: '미응시',
  weakAreasTitle: '약점 보강 대상',
  weakAreasEmpty: '현재 기록된 약점이 없습니다',

  // 구독 미등록 / 남은 레슨 미취득
  noSubscription: '플랜에 가입하면 레슨을 받을 수 있습니다',
  viewPlans: '플랜 보기',

  // 상태
  loading: '불러오는 중...',
  loadError: '진행 데이터를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
  retry: '다시 불러오기',

  // 애디셔널 플랜 (플레이스홀더)
  additionalTitle: '애디셔널 플랜',
  additionalBadge: '곧 공개',
  additionalSubtitle: 'A~C 레벨 수료 후 선택할 수 있는 전문 코스입니다. 준비가 되는 대로 안내해 드립니다.',
  additionalWorkplace: '직장 계열 코스',
  additionalWorkplaceDesc: '주방·호텔·접객 등 업무 환경 표현',
  additionalWordplay: '말놀이 계열 코스',
  additionalWordplayDesc: '줄임말·속담·슬랭',
  additionalComingSoon: '준비 중',
  additionalSelectPlaceholder: '코스 선택 (곧 공개)',
};
